import type { IntegrationKey } from "schemas/agentTools/integrationDefinitions";

import { getFromRecordOrNull } from "replo-utils/lib/misc";
import { opencodeToolIconKeyByName } from "schemas/agentTools/opencode";
import {
  isKnownIntegrationKey,
  knownIntegrationToolMetadataRegistry,
} from "schemas/agentTools/remote/integrations";
import { reploOpencodeHarnessToolIconKeyByName } from "schemas/agentTools/reploOpencodeHarness";

import { getMcpToolIconKey } from "./display/mcp/mcp";

export type KnownIntegrationDetails = {
  key: IntegrationKey;
  name: string;
  description: string;
  logoUrl: string | null;
  darkLogoUrl: string | null;
  image: string | null;
  docsUrl: string | null;
  connectionUi: string | null;
  nangoProviderConfigKey: string | null;
  useNangoMcp: boolean;
  usageGuidance: string | null;
};

export type OpencodeToolIconKey =
  | "bedrock"
  | "bedrockAnalytics"
  | "bedrockAssets"
  | "bedrockDatabase"
  | "bedrockDomains"
  | "bedrockIntegrations"
  | "bedrockMembers"
  | "bedrockOrders"
  | "bedrockProducts"
  | "bedrockRegistry"
  | "bedrockSettings"
  | "bedrockSites"
  | "bedrockTasks"
  | "bot"
  | "default"
  | "file"
  | "help"
  | "imageUpload"
  | "link"
  | "list"
  | "mediaMcp"
  | "nextDevtools"
  | "parallelSearch"
  | "publish"
  | "research"
  | "search"
  | "skill"
  | "terminal";

export function getKnownIntegrationDetails({
  integrationKey,
}: {
  integrationKey: string;
}) {
  return isKnownIntegrationKey(integrationKey)
    ? knownIntegrationToolMetadataRegistry[integrationKey]
    : null;
}

export function getOpencodeToolIconKey({ toolName }: { toolName: string }) {
  const normalizedToolName = toolName.toLowerCase();
  return (
    getFromRecordOrNull(opencodeToolIconKeyByName, normalizedToolName) ??
    getFromRecordOrNull(
      reploOpencodeHarnessToolIconKeyByName,
      normalizedToolName,
    ) ??
    getMcpToolIconKey({ toolName: normalizedToolName }) ??
    "default"
  );
}
